import { useBackofficeSearchCondition } from '@/providers/BackofficeSearchConditionProvider';
import { useEffect, useState } from 'react';
import { objectToQueryString } from '@/utils';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';

export const CsvExport = () => {
  const { _w_ } = useCurrentWorkspace();
  const { invoiceTaskSearchCondition: searchCondition } = useBackofficeSearchCondition();
  const [queryString, setQueryString] = useState<string>('');

  useEffect(() => {
    setQueryString((_) => objectToQueryString({ ...searchCondition }));
  }, [searchCondition]);

  return (
    <a
      href={`${process.env.REACT_APP_API_URL}/api/workspaces/${
        _w_!.identifier
      }/invoice_tasks/export_csv.csv?${queryString}`}
      className="btn btn-icon btn-dark me-3"
    >
      <i className="fas fa-file-download"></i> エクスポート
    </a>
  );
};
